import { axios } from '../interceptors';
import { BillEstimateResponse } from '../models/bill';
import { UtilService } from './util-service';

class BillService {
  private static baseUrl = '/bill';

  public static async getMonthlyEstimatedBill(
    userPlanCode: string,
    servicePointId: string,
    commercialRateEnabled: boolean | undefined,
  ) {
    const headers = UtilService.addFeatureHeader({}, commercialRateEnabled, 'COMMERCIAL_RATES');
    const response = await axios.get<BillEstimateResponse[]>(`${this.baseUrl}/estimate`, {
      params: {
        sp: servicePointId,
      },
      headers,
    });
    const estimations = response.data;
    const currentPlanEstimation = estimations.find((x) => x.planCode === userPlanCode);
    if (currentPlanEstimation) {
      currentPlanEstimation.totalPlanCharges = currentPlanEstimation.charges.reduce((curVal, charges) => curVal + charges.total, 0);
      for (const est of estimations) {
        est.totalPlanCharges = est.charges.reduce((curVal, charges) => curVal + charges.total, 0) || 0;
        est.estimatedSavings = Math.round(currentPlanEstimation.totalPlanCharges) - Math.round(est.totalPlanCharges) || 0;
      }
    }
    return estimations;
  }
}

export { BillService };
